import React, { useCallback, useEffect } from 'react';
import { Form, Row, Col, Select, AutoComplete, DatePicker, Button, Input } from 'antd';
import moment from 'moment';
import _ from 'lodash';
import { BOS_SEARCH_CONDITION_KEY, SLASH_DATE_FORMAT } from '../../../common/constants';
import { useFetchManageOutsOrders, useResetManageOutsData } from './redux/hooks';
import { useFetchBosTerritoryData, useFetchSearchPanelOrgInfo, useRetainConditionData, useResetConditionData,
} from '../redux/hooks';
import { useFetchConceptIdsData } from '../../dashboard/redux/hooks';

export default function ManageOutsAuditTrailSearchFilters(props) {
  const { fetchManageOutsOrders } = useFetchManageOutsOrders();
  const { resetManageOutsData } = useResetManageOutsData();
  const { bosTerritoryData, fetchBosTerritoryData } = useFetchBosTerritoryData();
  const { originalConstData, fetchSearchPanelOrgInfo } = useFetchSearchPanelOrgInfo();
  const { conceptData, fetchConceptIdsData } = useFetchConceptIdsData();
  const { retainConditionData } = useRetainConditionData();
  const { resetConditionData } = useResetConditionData();
  const [form] = Form.useForm();

  const siteOptions =
    originalConstData && originalConstData.sites && originalConstData.sites.length
      ? originalConstData.sites
      : bosTerritoryData && bosTerritoryData.sites
        ? bosTerritoryData.sites
        : [];
  const conceptOptions = conceptData || [];

  const getDefaultDeliveryDateRange = () => {
    const tomorrow = moment().add(1, 'days');
    return [tomorrow, tomorrow.clone()];
  };

  // Keys mirror SearchFiltersPanel's payload so filters survive across manage-subs screens.
  const buildManageOutsRetainedFilters = values => {
    const entered = (values.customerShipTo || '').toString().trim();
    const from = values.deliveryDate && values.deliveryDate[0];
    const to = values.deliveryDate && values.deliveryDate[1];

    const retainedFilters = {
      sites: values.opco ? [values.opco] : undefined,
      originalItem: values.originalItem || undefined,
      orderNumber: values.orderNo || undefined,
      orderNo: values.orderNo || undefined,
      deliveryDateFrom: from ? moment(from).format('YYYYMMDD') : undefined,
      deliveryDateTo: to ? moment(to).format('YYYYMMDD') : undefined,
    };

    if (entered) {
      if (/^\d{6}$/.test(entered)) {
        retainedFilters.customerNumber = entered;
        retainedFilters.customerShipTo = entered;
      } else {
        retainedFilters.nationalIds = [entered];
        retainedFilters.conceptId = entered;
      }
    }

    return Object.keys(retainedFilters).reduce((acc, key) => {
      if (retainedFilters[key] !== undefined && retainedFilters[key] !== '') {
        acc[key] = retainedFilters[key];
      }
      return acc;
    }, {});
  };

  const parseRetainedDate = value => {
    if (!value) return undefined;
    if (moment.isMoment(value)) return value;
    const dateValue = String(value);
    return /^\d{8}$/.test(dateValue) ? moment(dateValue, 'YYYYMMDD') : moment(value);
  };

  const applyRetainedFilters = useCallback(() => {
    const stored = JSON.parse(sessionStorage.getItem(BOS_SEARCH_CONDITION_KEY) || '{}');
    // if (_.isEmpty(stored)) {
    //   const [from, to] = getDefaultDeliveryDateRange();

    //   retainConditionData({
    //     deliveryDate: parseInt(from.format('YYYYMMDD'), 10),
    //     deliveryDateFrom: from.format('YYYYMMDD'),
    //     deliveryDateTo: to.format('YYYYMMDD'),
    //   });

    //   form.setFieldsValue({
    //     deliveryDate: [from, to],
    //   });

    //   return;
    // }
        if (_.isEmpty(stored)) {
      form.setFieldsValue({
        deliveryDate: getDefaultDeliveryDateRange(),
      });

      return;
    }

    const from = parseRetainedDate(stored.deliveryDateFrom);
    const to = parseRetainedDate(stored.deliveryDateTo);
    
    form.setFieldsValue({
      opco: Array.isArray(stored.sites) ? stored.sites[0] : stored.sites,
      customerShipTo:
        stored.customerShipTo ||
        stored.customerNumber ||
        stored.conceptId ||
        (Array.isArray(stored.nationalIds) ? stored.nationalIds[0] : undefined),
      originalItem: stored.originalItem,
      orderNo: stored.orderNumber || stored.orderNo,
      // ...(from && to ? { deliveryDate: [from, to] } : {}),
            deliveryDate: from && to ? [from, to] : getDefaultDeliveryDateRange(),
    });
  }, [form]);

  useEffect(() => {
    applyRetainedFilters();
  }, [applyRetainedFilters]);

  // Re-apply once sites resolve so the retained site renders with its description.
  useEffect(() => {
    if (siteOptions.length) applyRetainedFilters();
  }, [siteOptions.length, applyRetainedFilters]); // eslint-disable-line

  useEffect(() => {
    if (!originalConstData || !originalConstData.sites || originalConstData.sites.length === 0) {
      fetchSearchPanelOrgInfo(null, null, null).catch(() => { });
    }
    if (!bosTerritoryData) {
      fetchBosTerritoryData({ isSpecial: true });
    }
  }, []); // eslint-disable-line

  const updateValidator = useCallback(() => {
    form.validateFields();
  }, [form]);

  // const onFinish = (values) => {
  //   const { setSelectedOrder } = props;
  //   resetManageOutsData();
  //   setSelectedOrder(null);

  //   const entered = (values.customerShipTo || '').toString().trim();

  //   const formData = {
  //     site: values.opco,
  //     itemNumber: values.originalItem || undefined,
  //     orderNumber: values.orderNo || undefined,
  //     deliveryDateFrom:
  //       _.isUndefined(values.deliveryDate) || _.isNull(values.deliveryDate)
  //         ? undefined
  //         : moment(values.deliveryDate[0]).format('YYYYMMDD'),
  //     deliveryDateTo:
  //       _.isUndefined(values.deliveryDate) || _.isNull(values.deliveryDate)
  //         ? undefined
  //         : moment(values.deliveryDate[1]).format('YYYYMMDD'),
  //     pageIndex: 1,
  //     pageSize: 5,
  //   };

  //   if (entered) {
  //     // 6-digit numeric -> customerShipTo, otherwise treat as conceptId
  //     if (/^\d{6}$/.test(entered)) {
  //       formData.customerShipTo = entered;
  //     } else {
  //       formData.conceptId = entered;
  //     }
  //   }
  //   if (props.setSearchFilters) props.setSearchFilters(formData);

  //   fetchManageOutsOrders(formData);
  // };

  const onFinish = values => {
    const { setSelectedOrder } = props;
    resetManageOutsData();
    setSelectedOrder(null);

    const entered = (values.customerShipTo || '').toString().trim();

    const formData = {
      site: values.opco,
      itemNumber: values.originalItem || undefined,
      orderNumber: values.orderNo || undefined,
      deliveryDateFrom:
        _.isUndefined(values.deliveryDate) || _.isNull(values.deliveryDate)
          ? undefined
          : moment(values.deliveryDate[0]).format('YYYYMMDD'),
      deliveryDateTo:
        _.isUndefined(values.deliveryDate) || _.isNull(values.deliveryDate)
          ? undefined
          : moment(values.deliveryDate[1]).format('YYYYMMDD'),
      pageIndex: 1,
      pageSize: 5,
      identifierType: null,
    };

    if (entered) {
      if (/^\d{6}$/.test(entered)) {
        formData.customerShipTo = entered;
        formData.identifierType = 'customerShipTo';
      } else {
        formData.conceptId = entered;
        formData.identifierType = 'conceptId';
      }
    }

    const stored = JSON.parse(sessionStorage.getItem(BOS_SEARCH_CONDITION_KEY) || '{}');
    // Drop the opposite identifier so a concept search can't linger after a ship# search.
    const clearedIdentifiers = {
      customerNumber: undefined,
      customerShipTo: undefined,
      nationalIds: undefined,
      conceptId: undefined,
    };
    // retainConditionData's reducer also writes BOS_SEARCH_CONDITION_KEY, keeping redux and storage in sync.
    retainConditionData({
      ...stored,
      ...clearedIdentifiers,
      ...buildManageOutsRetainedFilters(values),
    });

    if (props.setSearchFilters) {
      props.setSearchFilters(formData);
    }
  };

  const onReset = () => {
    form.resetFields();
    resetConditionData();
    const { setSelectedOrder } = props;
    resetManageOutsData();
    setSelectedOrder(null);
    if (props.setSearchFilters) props.setSearchFilters({});
  };

  const requiredSomeoneValidator = (rule, value) => {
    const { orderNo, originalItem } = form.getFieldsValue();
    if (
      (_.isUndefined(orderNo) || orderNo.length === 0) &&
      (_.isUndefined(originalItem) || originalItem.length === 0)
    ) {
      return Promise.reject('At least one of Order # or Original Item is required.');
    }
    return Promise.resolve();
  };

  const onSearchConcept = value => {
    if (!value || value.length < 4) return;
    const opco = form.getFieldValue('opco');
    const siteArg = opco ? [opco] : null;
    fetchConceptIdsData(value.toUpperCase().substr(0, 4), value.toUpperCase(), siteArg);
  };

  return (
    <div className="manage-outs-search-filters">
      <Form
        form={form}
        className="filter-form"
        layout="vertical"
        onFinish={onFinish}
        // initialValues={{
        //   deliveryDate: [moment().subtract(1, 'days'), moment()],
        // }}
        initialValues={{
          deliveryDate: getDefaultDeliveryDateRange(),
        }}
      >
        <Row className="font-size-16 sub-title">
          <Col>Order Search</Col>
        </Row>

        <Form.Item name="opco" label="Site" rules={[{ required: true, message: 'Please select a site' }]}>
          <Select showSearch placeholder="Select site">
            {siteOptions.map(s => (
              <Select.Option key={s.site_nbr || s.siteNbr} value={s.site_nbr || s.siteNbr}>
                {(s.site_nbr || s.siteNbr)}
                {(s.site_desc || s.site_name) ? ` - ${s.site_desc || s.site_name}` : ''}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>


        <Form.Item
          name="customerShipTo"
          label="Concept / Ship #"
          rules={[{ required: true, message: 'Please enter a Concept / Ship #' }]}
          validateTrigger={['onBlur', 'onChange']}
        >
          <AutoComplete
            placeholder="Type to search (min 4 chars) or enter number"
            options={conceptOptions.map(c => ({ value: c }))}
            onSearch={onSearchConcept}
            filterOption={false}
            onSelect={value => form.setFieldsValue({ customerShipTo: value })}
            onChange={value => form.setFieldsValue({ customerShipTo: value })}
            allowClear
          />
        </Form.Item>


        <Form.Item
          name="deliveryDate"
          label="Delivery Date"
          rules={[{ required: true, message: 'Please select a delivery date range' }]}
        >
          <DatePicker.RangePicker format={SLASH_DATE_FORMAT} />
        </Form.Item>

        <Form.Item
          name="originalItem"
          label="Original Item"
          rules={[{ required: true, message: 'Please enter Original Item' }]}
          validateTrigger={['onBlur', 'onChange']}
        >
          <Input placeholder="e.g. 00123456" />
        </Form.Item>

        <Form.Item name="orderNo" label="Order # (optional)">
          <Input placeholder="SUS or Shop Order #" />
        </Form.Item>

        <Form.Item style={{ textAlign: 'end' }}>
          <Button
            htmlType="button"
            type="link"
            onClick={onReset}
            className="default-btn filter-btn"
            style={{ marginRight: '10px' }}
          >
            Reset
          </Button>
          <Button htmlType="submit" type="primary" className="primary-btn filter-primary-btn">
            Search
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

ManageOutsAuditTrailSearchFilters.propTypes = {};
ManageOutsAuditTrailSearchFilters.defaultProps = {};


